import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Suppress React DevTools semver error in development
// This error comes from Chrome extension, not our app
if (process.env.NODE_ENV === "development" && typeof window !== "undefined") {
  const isDevToolsSemverError = (message, filename) => {
    const msg = String(message || "");
    const file = String(filename || "");
    return (
      file.includes("chrome-extension://") &&
      (file.includes("react_devtools") || file.includes("devtools")) &&
      msg.includes("Invalid argument not valid semver")
    );
  };

  // Intercept before CRA overlay
  const originalError = window.onerror;
  window.onerror = function (message, source, lineno, colno, error) {
    if (isDevToolsSemverError(message, source)) {
      return true;
    }
    if (originalError) {
      return originalError.apply(this, arguments);
    }
    return false;
  };

  window.addEventListener(
    "error",
    (event) => {
      if (isDevToolsSemverError(event?.message, event?.filename)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  window.addEventListener(
    "unhandledrejection",
    (event) => {
      const reason = event?.reason;
      const message = reason?.message || reason || "";
      if (String(message).includes("Invalid argument not valid semver")) {
        event.preventDefault();
      }
    },
    true
  );

  // Hide overlay if it still appears (fallback)
  const hideOverlay = () => {
    const selectors = [
      "[data-react-error-overlay]",
      'iframe[src*="react-error-overlay"]',
      'div[id*="react-error"]',
      'div[class*="react-error"]',
    ];
    for (const selector of selectors) {
      const overlay = document.querySelector(selector);
      if (overlay) {
        const text = overlay.textContent || "";
        if (text.includes("Invalid argument not valid semver")) {
          overlay.style.display = "none";
          overlay.remove();
        }
      }
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", hideOverlay);
  } else {
    hideOverlay();
  }
  setInterval(hideOverlay, 500);
  new MutationObserver(hideOverlay).observe(document.body, {
    childList: true,
    subtree: true,
  });
}

const Root = () => {
  useEffect(() => {
    const loader = document.getElementById("loader");
    if (loader) {
      loader.style.transition = "opacity 0.3s ease";
      loader.style.opacity = "0";
      setTimeout(() => loader.remove(), 300);
    }
  }, []);

  return <App />;
};

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("No root element");
const root = ReactDOM.createRoot(rootElement);
root.render(<Root />);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(
        registrations
          .filter((reg) =>
            reg.active?.scriptURL.includes("firebase-messaging-sw.js"),
          )
          .map((reg) => reg.unregister()),
      );

      await navigator.serviceWorker.register("/sw.js", { scope: "/" });
    } catch (err) {
      console.error("SW registration failed:", err);
    }
  });
}
